<template>
  <v-container grid-list-md >
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion mb-2" v-html="loadedLessons.instructions_spanish"></p>
        <p class="ejemplo-bg primary py-3 px-3 radius mt-1 white--text" v-html="loadedLessons.exercise"></p>
      </div>
      <div class="e-ejercicio-ejercicio  pt-0">
        <v-layout  pt-0 row wrap>
          <SubCardColumna 
          v-for="(option, index) in loadedLessons.options"
          :key="`subcard-${index}`"
          :respuesta="option"
          />
          <v-flex>
            <v-btn
            block
            round
            large
            router-link
            :to="`/practica/avanzada/${idUnidad}/ejercicio/practicaFin`"
            class="elevation-0"
            color="primary">
              COMPROBAR
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SubCardColumna from '../../../components/Practica/basica/SubCardColumna'
import CardTexto from '../../../components/Practica/Global/CardTexto'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: "PracticaColumna",
  props: ['idUnidad'],
  data() {
    return {
      respuestas: [
        {
          id: 0,
          text: '사어 드릴게요.',
          estado: true
        },
        {
          id: 1,
          text: '사아 드릴게요.',
          estado: false
        }
      ]
    }
  },
  created () {
    this.loadLessons()
  },
  components: {
    SubCardColumna,
    CardTexto
  },
  computed: {
    ...mapState({
      ui: state => state.ui
    }),
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 1)
      return data[0]
    }
  },
  methods: {
    ...mapActions('ui', [
      'texto'
    ]),
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 1
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  }
}
</script>

